import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types';
import { Alert, Button, Card, Col, Container, Form, FormGroup, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';
import { useSelector } from 'react-redux';
import { BillingAPI } from '../../components/apis/billing';
import { useForm } from 'react-hook-form';
import types from '../../types/types';
import ReactTable from '../../components/helpers/ReactTable';
import { useColumns } from '../../hook/useColumns';
import { useTable } from 'react-table';
import { ButtonGeneric } from '../../components/common/ButtonGeneric';
import { ButtonAddEntity } from '../../components/common/ButtonAddEntity';

export const Management = (props, context) => {

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);
    const { isLoading: accordionStack, showSpinner: showAccordionStack, hideAccordionStack } = useisLoading(true);

    // const plansColumns = useMemo(() => PLANS_COLUMNS, []);
    const {getColumnsConfigurationElements, getColumnsBillingPlanInternal, getColumnsBillingPlanAccount } = useColumns(context);
    
    const [headerDataConfigurationElements, setHeaderDataConfigurationElements] = useState(useMemo(() => getColumnsConfigurationElements(), []))
    const [rowsDataConfigurationElements, setRowsDataConfigurationElements] = useState([]);

    const [headerDataBillingPlanInternal, setHeaderDataBillingPlanInternal] = useState(useMemo(() => getColumnsBillingPlanInternal(), []))
    const [rowsDataBillingPlan, setRowsDataBillingPlan] = useState([]);

    const [headerDataBillingPlanAccount, setHeaderDataBillingPlanAccount] = useState(useMemo(() => getColumnsBillingPlanAccount(), []))
    const [rowsDataBillingPlanAccount, setRowsDataBillingPlanAccount] = useState([]);
    

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue } = useForm({
        defaultValues: {
        }
    });

    const { token } = useSelector(state => state.user);

    const [apiBilling, setApiBilling] = useState(null);

    // Load API Object
    useEffect(() => {

        if (token) {
            setApiBilling(new BillingAPI(token));
        }

    }, [token])

    // Use effect to load configuration elements data from managment API.
    useEffect( () => {
        if (apiBilling){
            
            showSpinner();    
            
            apiBilling.getConfigurationElements().then(  (elements) => {
                
                setRowsDataConfigurationElements(elements)     

            }).catch(err => {
                console.log("Error getting configuration elements data from Management.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            }).finally(() => {

                hideSpinner();

            });
        }

    }, [apiBilling]);
    
    // Use effect to load standar commercial plans data from managment API.
    useEffect( () => {
        if (apiBilling){
            
            showSpinner();    
            
            apiBilling.getSnxBillingPlanBase().then(  (standardPlans) => {

                setRowsDataBillingPlan(standardPlans)     

            }).catch(err => {
                console.log("Error getting standar commercial plans data from Management.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            }).finally(() => {

                hideSpinner();

            });
        }

    }, [apiBilling]);

    // Use effect to load Billing plan by Account from managment API.
    useEffect( () => {
        if (apiBilling){
            
            showSpinner();    
            apiBilling.getBillingPlanAccounts().then(  (plans) => {

                setRowsDataBillingPlanAccount(plans)     
                hideSpinner();

            }).catch(err => {
                console.log("Error getting Billing plan by Account data from Management.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            }).finally(() => {

                hideSpinner();

            });
        }

    }, [apiBilling]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ 
        columns: headerDataBillingPlanAccount,
        data: rowsDataBillingPlanAccount,
    });

    // // Retrive Account name given its ID.
    // const _getAccountName = (id) => {
    //     var result = "";
    //     accounts.filter(accountElement => {
    //         if (accountElement.id === Number(id) ){
    //             result = accountElement.name
    //         }
    //     })               
    //     return result;                                                                        
    // }
    

    if (isLoading) {
        return (
            <Loading />  
        )
    } else {
        return ( <>
            <Container fluid className="main-content-container px-4">
                <br/>
                <Row>
                    <Col lg="12">
                        <Card className="mb-4">
                        <Card.Header className="border-bottom pt-2">
                            <h5 className="m-0">{context.t('Management')}</h5>
                            <h6 className="m-0">{context.t('Commercial plans, prices list and bonifications')}</h6>

                            {/* <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px" }} onClick={e => { history.goBack() }}>arrow_back</i> */}
                        </Card.Header>
                        <Card.Body className="pt-1">
                            {/* <Row className="border-bottom py-2 bg-light">
                                <Col sm="6" className="mb-2 mb-sm-0" style={{ paddingTop: "7px" }}></Col>
                            </Row> */}
                            <Row className='mt-2'></Row>
                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                        <AccordionItemButton >
                                                            Configuration Elements
                                                        </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel > 
                                                {(accordionStack)?(
                                                    <>
                                                        <Row>
                                                            <Col lg="10"></Col>
                                                            <Col lg="2">
                                                                <ButtonAddEntity id="UG_elements" to={'/configurationElement/new'} icon="settings"/>
                                                            </Col>
                                                        </Row>
                                                        <div>
                                                            <ReactTable headerData={headerDataConfigurationElements} rowsData={rowsDataConfigurationElements} actionURI={"/configurationElement/view/"} idReference={"id"} />
                                                        </div>
                                                    </>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row className='mt-2'></Row>
                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                        <AccordionItemButton >
                                                            Commercial Plans
                                                        </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel > 
                                                {(accordionStack)?(
                                                    <>
                                                        <Row>
                                                            <Col lg="10"></Col>
                                                            <Col lg="2">
                                                                <ButtonAddEntity id="UG_commercialPlanAddEntity" to={'/planEdition/new'} icon="add_shopping_cart"/>
                                                            </Col>
                                                        </Row>
                                                        <div>
                                                            <ReactTable headerData={headerDataBillingPlanInternal} rowsData={rowsDataBillingPlan} actionURI={"/planEdition/view/"} idReference={"id"} />
                                                        </div>
                                                    </>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row className='mt-2'></Row>
                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded preExpanded={['a']}>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                <AccordionItemButton>
                                                    Commercial Plans by Accounts
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel> 
                                                {(accordionStack)?(
                                                    <>
                                                        <Row>
                                                            <Col lg="10"></Col>
                                                            <Col lg="2">
                                                                <ButtonAddEntity id="UG_commercialPlanAddEntity" to={'/planEdition/new'} icon="shopping_cart"/>
                                                            </Col>
                                                        </Row>
                                                    <Container>
                                                        {/* <ReactTable headerData={headerDataBillingPlanAccount} rowsData={rowsDataBillingPlanAccount} actionURI={"/customerplan/view/"} /> */}
                                                        <table className="table table-sm scrollable-div">
                                                            <thead>
                                                                {headerGroups.map((headerGroup) => (
                                                                <tr {...headerGroup.getHeaderGroupProps()}>
                                                                    {headerGroup.headers.map((column) => (
                                                                    <th {...column.getHeaderProps()} scope="col">
                                                                        {column.render("Header")}
                                                                    </th>
                                                                    ))}
                                                                </tr>
                                                                ))}
                                                            </thead>
                                                            <tbody {...getTableBodyProps()}>
                                                                {rows.map((row) => {
                                                                prepareRow(row);
                                                                return (
                                                                    <tr {...row.getRowProps()}>
                                                                    {row.cells.map((cell) => {
                                                                        // Replacing "account_id" value for Account Name retrived from Redux
                                                                        return  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                                    })}
                                                                        <td>
                                                                            <ButtonGeneric icon={"remove_red_eye"} to={"/customerplan/view/" + row.original.account_id }/>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </Container>
                                                    </>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                        </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>)
    }
}

Management.contextTypes = {
    t: PropTypes.func.isRequired
}

export default Management